const Director = "Director"
const Manager = "Manager"
const SalesExecutive = "SalesExecutive"
const Logistics = "Logistics"

const REGION_ROUTE_ROLES = [
  Director,
  SalesExecutive,
  Manager,
  Logistics,
]

export default [
  {
    path: '/regions',
    name: 'Regions',
    component: () => import('@/_backoffice/_registrations/components/region/Regions.vue'),
    meta: {
      auth: true,
      roles: REGION_ROUTE_ROLES,
    },
  },
]
